import React from "react";
import "./app.css";
import { getImage } from "../../../../../../utils/getImages";

const getFileType = (file) => {
  if (!file) return "unknown";

  let ext = "";

  // Case 1: If file is a string (URL or file path)
  if (typeof file === "string") {
    const parts = file.split("?");
    const cleanUrl = parts[0]; // remove query params
    ext = cleanUrl.split(".").pop()?.toLowerCase();
  }

  // Case 2: If file is a File object (from input)
  else if (file instanceof File) {
    ext = file.name.split(".").pop()?.toLowerCase();
  }

  if (!ext) return "unknown";

  if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
  if (["mp4", "webm", "mov", "avi"].includes(ext)) return "video";
  if (["mp3", "wav", "ogg"].includes(ext)) return "audio";
  if (["pdf"].includes(ext)) return "pdf";
  if (["doc", "docx"].includes(ext)) return "doc";
  if (["xls", "xlsx"].includes(ext)) return "xls";

  return "unknown";
};

const renderPreview = (fileUrl) => {
  if (!fileUrl) return null;
  const fileType = getFileType(fileUrl);

  switch (fileType) {
    case "image":
      return (
        <img
          src={getImage(fileUrl)}
          style={{ width: "100%", padding: "10px" }}
          alt="preview"
        />
      );
    case "video":
      return (
        <video
          src={getImage(fileUrl)}
          controls
          style={{ width: "100%", maxHeight: "400px", padding: "10px" }}
        />
      );
    case "audio":
      return (
        <audio
          src={getImage(fileUrl)}
          controls
          style={{ width: "100%", padding: "10px" }}
        />
      );
    case "pdf":
      return (
        <iframe
          src={getImage(fileUrl)}
          style={{
            width: "100%",
            height: "500px",
            border: "none",
            padding: "10px",
          }}
        />
      );
    case "doc":
      return (
        <div style={{ padding: "10px", fontWeight: "bold" }}>
          📄 Word Document uploaded
        </div>
      );
    case "xls":
      return (
        <div style={{ padding: "10px", fontWeight: "bold" }}>
          📊 Excel File uploaded
        </div>
      );
    default:
      return (
        <div style={{ padding: "10px", fontWeight: "bold" }}>
          📁 File uploaded
        </div>
      );
  }
};

const Blogview = ({ cardData, activetab }) => {
  return (
    <div>
      {/* First description */}
      <div style={{ padding: "10px 50px", borderRadius: "10px" }}>
        <div
          dangerouslySetInnerHTML={{
            __html:
              activetab === "english"
                ? cardData?.description
                : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_description
                : activetab === "arabic"
                ? cardData?.arabic_description
                : activetab === "bahasa"
                ? cardData?.bahasa_description
                : cardData?.traditional_chinese_description,
          }}
        />
      </div>

      {/* File preview (image / video / audio / pdf / etc.) */}
      <div style={{ padding: "10px 50px" }}>
        {renderPreview( activetab === "english"
                ? cardData?.image
                : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_image
                : activetab === "arabic"
                ? cardData?.arabic_image
                : activetab === "bahasa"
                ? cardData?.bahasa_image
                : cardData?.traditional_chinese_image,)}
      </div>

      {/* Second description */}
      <div style={{ padding: "10px 50px", borderRadius: "10px" }}>
        <div
          dangerouslySetInnerHTML={{
            __html:( activetab === "english"
                ? cardData?.description1
                : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_description1
                : activetab === "arabic"
                ? cardData?.arabic_description1
                : activetab === "bahasa"
                ? cardData?.bahasa_description1
                : cardData?.traditional_chinese_description1),
          }}
        />
      </div>
    </div>
  );
};

export default Blogview;
